<form data-cy="employment-working-availability-dialog">
  <div mat-dialog-title>
    <h1 mat-dialog-title>{{ data.personName }}</h1>
  </div>
  <div mat-dialog-content>
    <h2>{{ ("type" | i18n) || "Typ" | titlecase }}</h2>
    <div class="booked-type-row">
      <div class="booked-type">{{ ("booked" | i18n) || "Gebucht" }}</div>
      <div class="booked-department">
        <mat-icon
          svgIcon="work"
          size="18"></mat-icon>
        <ng-container *ngIf="data.isOwnBooked; else bookedAnonymized">
          <span>{{ data.organisationName }}</span>
          {{ data.departmentName }}
        </ng-container>
        <ng-template #bookedAnonymized>
          <span>{{ ("inEmployment" | i18n) || "Im Einsatz" }}</span>
        </ng-template>
      </div>
    </div>
    <div class="row">
      <h2 mat-dialog-title>
        {{ ("timespan" | i18n) || "Zeitraum" | titlecase }}
      </h2>
      <div class="col-md-6">
        <mat-form-field>
          <mat-label>{{
            ("dateFrom" | i18n) || "Datum von" | titlecase
          }}</mat-label>
          <input
            matInput
            [value]="(data.startDate | date) || ''"
            readonly
            required
            disabled
            data-cy="datepicker-from" />
          <input
            matInput
            required
            disabled
            name="datepicker"
            [(ngModel)]="data.startDate"
            hidden />
          <mat-datepicker-toggle matSuffix></mat-datepicker-toggle>
        </mat-form-field>
      </div>
      <div class="col-md-6">
        <mat-form-field>
          <mat-label>{{
            ("dateTo" | i18n) || "Datum bis" | titlecase
          }}</mat-label>
          <input
            matInput
            [value]="(data.endDate | date) || ''"
            readonly
            disabled
            required
            data-cy="datepicker-to" />
          <input
            matInput
            required
            disabled
            name="datepicker"
            [(ngModel)]="data.endDate"
            hidden />
          <mat-datepicker-toggle matSuffix></mat-datepicker-toggle>
        </mat-form-field>
      </div>
      <div
        *ngIf="data.unavailabilities?.length"
        class="col-md-12">
        <h2 mat-dialog-title>
          {{ ("absences" | i18n) || "Abwesenheiten" | titlecase }}
        </h2>
        <div
          *ngFor="let absence of data.unavailabilities"
          class="absence">
          {{ absence.from | date: "dd.MM.yyyy" }} -
          {{ absence.to | date: "dd.MM.yyyy" }} -
          <span>
            {{
              ("unavailabilityReasonEnum." + absence.reason | i18n) ||
                absence.reason
            }}</span
          >
        </div>
      </div>
    </div>
  </div>
  <div mat-dialog-actions>
    <button
      mat-button
      (click)="onNoClick()">
      {{ ("close" | i18n) || "schliessen" | uppercase }}
    </button>
  </div>
</form>
